module.exports = __webpack_public_path__ + "static/media/start_of_a_journey.7bcdf59c.md";